import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import {forkJoin, map, startWith, Subject, takeUntil} from 'rxjs';
import { itemsVM } from '../../../Model/items/itemsVM';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { BuySellOrderService } from '../../../Services/buy-sell-order.service';
import { DtoAgentVM } from '../../../Model/agents/DtoAgentVM';
import { SharedService } from '../../../Shared/Services/shared.service';
import { DtoBuySellOrderVm } from '../../../Model/items/DtoBuySellOrderVm';
import { DtoProductListVM } from '../../../Model/price-list/DtoProductListVM';
import * as arabicStrings from '@flowdegree/arabic-strings';

@Component({
  selector: 'app-buy-order',
  templateUrl: './buy-order.component.html',
  styleUrl: './buy-order.component.scss'
})
export class BuyOrderComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  form!: FormGroup;
  AllSectors: DtoProductListVM = {};
  AllAccessories: DtoProductListVM = {};
  isFirstTab: boolean = true;
  // AllItems!: itemsVM[];
  AllSuppliers: DtoAgentVM[] = [];
  DtoBuySellOrder!: DtoBuySellOrderVm;
  showInvoice = false;
  isSupplier: boolean = false;
  filteredOptions: any[] = [];
  filteredSuppliersOptions: any[] = [];
  loadingItems: boolean = true;

  constructor(private fb: FormBuilder, private api: BuySellOrderService, private auth: AuthService, private spinner: NgxSpinnerService,
    private router: Router, private toastrService: CustomToastrService, private dialogService: DialogService
    , private shared: SharedService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      this.spinner.show();
      this.initForm();
      this.GetLookups();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  initForm() {
    this.form = this.fb.group({
      SectorItems: this.fb.array([]),
      AccessoriesItems: this.fb.array([])
    });
    if(this.isSupplier){
      this.ShowSupplier();
    }
  }

  get f() {
    return this.form.controls;
  }

  get SectorItems() {
    return this.form.controls["SectorItems"] as FormArray;
  }

  get AccessoriesItems() {
    return this.form.controls["AccessoriesItems"] as FormArray;
  }

  get GetSectorItems() {
    return this.SectorItems.controls as FormGroup[];
  }

  get GetAccessoriesItems() {
    return this.AccessoriesItems.controls as FormGroup[];
  }

  get ShowAccessoriesTab(): boolean {
    return this.GetAccessoriesItems.length > 0;
  }

  get ShowSectorsTab(): boolean {
    return this.GetSectorItems.length > 0;
  }

  tabClick(tab: any) {
    if (tab.index == 0) {
      this.isFirstTab = true;
    }
    else if (tab.index == 1) {
      this.isFirstTab = false;
    }
  }


  GetLookups() {
    this.GetAllItems();
  }

  GetAllItems() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      let requests = [this.api.GetAllSuppliers(), this.api.GetAllAccessories(), this.api.GetAllSectors()];
      forkJoin(requests).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.AllSuppliers = res[0].result.payload;
          this.ManageSupplierControl("supplierId", "name");
          this.filteredSuppliersOptions = this.AllSuppliers;
          this.AllAccessories = res[1].payload;
          this.AllSectors = res[2].payload;

          this.addItems(this.AllAccessories, false);
          this.addItems(this.AllSectors, true);
          this.isFirstTab = true;
          this.loadingItems = false;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  resetItems() {
    this.form.controls["SectorItems"] = this.fb.array([]);
    this.form.controls["AccessoriesItems"] = this.fb.array([]);
    this.addItems(this.AllAccessories, false);
    this.addItems(this.AllSectors, true);
  };

  addItems(obj: DtoProductListVM, isSector: boolean) {
    let supplierId = this.form.controls["supplierId"]?.value;
    obj.productListHaveColols?.map(prod => {
      const itemForm = this.fb.group({
        productId: [prod.productId],
        productCode: [prod.productCode],
        productName: [prod.productName],
        haveColor: [prod.haveColor],
        colorId: [prod.colorId],
        colorName: [prod.colorName],
        variants: this.fb.array(this.createColorsValidators(prod))
      });
      if((this.isSupplier &&  prod.supplierId == supplierId) || (!this.isSupplier && prod.supplierId == null)) {
        if (isSector)
          this.SectorItems.push(itemForm);
        else
          this.AccessoriesItems.push(itemForm);
      }
    });

    obj.productListNoColors?.map(prod => {
      const itemForm = this.fb.group({
        id: [prod.id],
        productId: [prod.productId],
        productCode: [prod.productCode],
        productName: [prod.productName],
        haveColor: [prod.haveColor],
        colorId: [prod.colorId],
        colorName: [prod.colorName],
        count: [''],
      });
      if((this.isSupplier &&  prod.supplierId == supplierId) || (!this.isSupplier && prod.supplierId == null)) {
        if (isSector)
          this.SectorItems.push(itemForm);
        else
          this.AccessoriesItems.push(itemForm);
      }
    });
  }

  createColorsValidators(prod: any): FormGroup[] {
    var colors: FormGroup[] = [];
    prod.variants?.forEach((variant: any) => {
      const itemColor = this.fb.group({
        id: [variant.id, Validators.required],
        colorId: [variant.colorId, Validators.required],
        colorName: [variant.colorName],
        count: [''],
      });

      colors.push(itemColor);
    });

    return colors;
  }

  createCountValidators(): FormGroup[] {
    var colors: FormGroup[] = [];
    const itemColor = this.fb.group({
      count: [''],
    });

    colors.push(itemColor);
    return colors;
  }

  displaySupplierFn(itemID?: any): any {
    return this.AllSuppliers?.find(item => item.id === itemID)?.name;
  }

  submit() {
    this.getFormValidationErrors(this.form);
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoSaveThis',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          this.SubmitBuyOrder(this.form.value);
        }
      });
    }
    else {
      this.getFormValidationErrors(this.form);
    }
  }

  getFormValidationErrors(form: FormGroup) {
    Object.keys(this.form.controls).forEach(key => {
      let formGroups = (this.form.controls["SectorItems"] as FormArray).controls as FormGroup[];
      if (formGroups?.length > 0) {
        formGroups.forEach(formGroup => {
          Object.keys(formGroup?.controls).forEach(control => {
            this.shared.FireControlValidation(formGroup, control);
          });
        });
      }
      else {
        let formGroups = (this.form.controls["AccessoriesItems"] as FormArray).controls as FormGroup[];
        if (formGroups?.length > 0) {
          formGroups.forEach(formGroup => {
            Object.keys(formGroup?.controls).forEach(control => {
              //const controlList = form.get(control);

              this.shared.FireControlValidation(formGroup, control);
            });
          });
        } else {
          this.shared.FireControlValidation(this.form, key);
        }
      }
    });
  }

  SubmitBuyOrder(form: any) {
    this.spinner.show();
    let accessories = this.GetFormItems(form.AccessoriesItems);
    let sectors = this.GetFormItems(form.SectorItems);
    this.api.InsertBuyOrder({supplierId: form.supplierId, accessories: accessories, sectors: sectors}).pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            if (data.isSuccess) {
              this.toastrService.showSuccessToast('Success', 'AddedSuccessfully');
              this.DtoBuySellOrder = data.payload;
              this.showInvoice = true;
            } else {
              this.toastrService.showErrorToast('Error', data.message);
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }

  CloseInvoice(data: any) {
    this.showInvoice = false;
  }

  ChooseBuyFrom(isSupplier: any) {
    this.isSupplier = isSupplier;
    if (!isSupplier) {
      this.form.removeControl('supplierId');
    }
    else {
      this.ShowSupplier();
    }
    this.RedrawItems();
  }

  GetFormItems(items: any[]): {productId: number, count: number, productName: string, color?: string, colorId?: number}[] {
    return items.reduce((acc: any, curr: any) => {
      if(curr.variants && curr.variants.length > 0) {
        acc.push(curr.variants.filter((v: any) => v.count > 0).reduce((vAcc: any, vCurr: any) => {
          vAcc.push({productId: vCurr.id, count: vCurr.count, productName: curr.productName, color: vCurr.colorName, colorId: vCurr.colorId});
          return vAcc;
        }, []));
      }
      if(curr.count > 0) {
        acc.push({productId: curr.id, count: curr.count, productName: curr.productName});
      }
      return acc;
    }, []).flat();
  }
  filterAutocomplete(list: any[], name: string, column: any): any[] {
    name = arabicStrings.sanitize(name!);
    const filterValue = name.toLowerCase();
    return list.filter((option: any) => arabicStrings.sanitize(option[column]!.toLowerCase()).indexOf(filterValue) === 0);
  }

  ManageSupplierControl(control: any, column: any) {
    if (this.AllSuppliers) {
      this.form.controls[control]?.valueChanges
        .pipe(
          startWith<string | any>(''),
          map(value => typeof value === 'string' ? value : value.column),
          map(name => name ? this.filterAutocomplete(this.AllSuppliers, name, column) : this.AllSuppliers.slice())
        ).subscribe({
        next: (res: any) => {
          this.filteredSuppliersOptions = res;
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
    }
  }

  RedrawItems(): void {
    this.resetItems();
    this.form.updateValueAndValidity();
    this.loadingItems = true;
    let comp = this;
    setTimeout(() => {
      comp.loadingItems = false;
    }, 100);
  }


  ShowSupplier(): void{
    this.form.addControl('supplierId', this.fb.control('', Validators.required));
    this.form.controls["supplierId"].valueChanges.subscribe(value => {
      this.RedrawItems();
    });
  }

  UpdateForm(items: FormGroup[], type: string) {
    if(type == "sector") {
      this.form.controls["SectorItems"] = this.fb.array(items);
    }
    else if(type == "accessories") {
      this.form.controls["AccessoriesItems"] = this.fb.array(items);
    }
  }
}
